import React, { useState, useEffect } from 'react';
import { supabase } from '../../../config/supabase';
import './OrdersByHourChart.css';

const OrdersByHourChart = () => {
  const [hourlyData, setHourlyData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHourlyData();
  }, []);

  const fetchHourlyData = async () => {
    setLoading(true);
    try {
      // Get last 30 days of orders
      const thirtyDaysAgo = new Date();
      thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
      thirtyDaysAgo.setHours(0, 0, 0, 0);

      const { data: orders, error } = await supabase
        .from('orders')
        .select('created_at')
        .gte('created_at', thirtyDaysAgo.toISOString());

      if (error) throw error;

      // Initialize hourly counts
      const hourlyCounts = {};
      for (let i = 0; i < 24; i++) {
        const hourLabel = i === 0 ? '12 AM' : i < 12 ? `${i} AM` : i === 12 ? '12 PM' : `${i - 12} PM`;
        hourlyCounts[i] = { hour: hourLabel, orders: 0 };
      }

      // Count orders by hour
      (orders || []).forEach(order => {
        const orderDate = new Date(order.created_at);
        const hour = orderDate.getHours();
        hourlyCounts[hour].orders++;
      });

      // Convert to array
      const dataArray = Object.values(hourlyCounts);
      setHourlyData(dataArray);
    } catch (error) {
      console.error('Error fetching hourly data:', error);
      setHourlyData([]);
    } finally {
      setLoading(false);
    }
  };

  const maxOrders = hourlyData.length > 0 ? Math.max(...hourlyData.map(d => d.orders)) : 1;
  const peakHour = hourlyData.find(d => d.orders === maxOrders);

  return (
    <div className="chart-card">
      <div className="chart-header">
        <div>
          <h3 className="chart-title">Orders by Hour</h3>
          <p className="chart-subtitle">Peak ordering times</p>
        </div>
      </div>

      <div className="orders-hour-chart">
        {loading ? (
          <div style={{ padding: '40px', textAlign: 'center', color: '#6C757D' }}>Loading data...</div>
        ) : (
        <div className="bar-chart-container">
          {hourlyData.map((d, i) => (
            <div key={i} className="bar-wrapper-hour">
              <div
                className={`bar-hour ${d.orders === maxOrders ? 'peak' : ''}`}
                style={{
                  height: `${(d.orders / maxOrders) * 100}%`,
                  minHeight: d.orders > 0 ? '4px' : '0'
                }}
                title={`${d.hour}: ${d.orders} orders`}
              />
              <div className="bar-label-hour">{d.hour}</div>
            </div>
          ))}
        </div>
        )}
      </div>

      <div className="peak-hour-insight">
        <span className="insight-icon">⏰</span>
        <span>
          Peak hour: <strong>{peakHour?.hour}</strong> ({peakHour?.orders} orders)
        </span>
      </div>
    </div>
  );
};

export default OrdersByHourChart;

